function tables() {

    var cform = $('#tables-form');

    if(!cform.length) {
        return;
    }

    cform.find("#phone_number").intlTelInput({
        geoIpLookup: function(callback) {
            $.get("https://ipinfo.io/geo?token=55f8bb92e9e29b", function() {}, "jsonp").always(function(resp) {
                var countryCode = (resp && resp.country) ? resp.country : "US";
                callback(countryCode);
            });
        },
        initialCountry: "auto",
        preferredCountries: ['us'],
        separateDialCode: true,
        utilsScript: theme_url + "/assets/vendor/intl-tel-input-master/build/js/utils.js"
    });

    $.validator.addMethod('validateIntlPhone', function(value, element, param, method) {
        return $(element).intlTelInput('isValidNumber');
    }, "Please enter a valid phone number.");

    cform.validate({
        messages: {
            first_name: {
                //required: globals.passport_labels.errors.required,
                letterswithbasicpunc: "Please provide letters or punctuation only.",
            },
            last_name: {
                //required: globals.passport_labels.errors.required,
                letterswithbasicpunc: "Please provide letters or punctuation only.",
            },
            phone_number: {
                //required: globals.passport_labels.errors.required,
                validateIntlPhone: "Please enter a valid phone number.",
            },
            client_email: {
                //required: globals.passport_labels.errors.required,
                //email: globals.passport_labels.error.email_valid,
                //emailNeverbounce: globals.passport_labels.error.email_valid,
            },
            confirm_email: {
                //required: globals.passport_labels.errors.required,
                equalTo: errors.matchemail,
            },
        },
        rules: {
            first_name: {
                required: true,
                //letterswithbasicpunc: true,
            },
            last_name: {
                required: true,
                //letterswithbasicpunc: true,
            },
            phone_number: {
                required: true,
                validateIntlPhone: true,
            },
            client_email: {
                required: true,
                email: true,
                //emailNeverbounce: true,
            },
            confirm_email: {
                required: true,
                equalTo: "#client_email",
            },
        },
        /*
        showErrors: function(errorMap, errorList) {
            if(errorList.length) {
                var messages = [];
                $.each(errorList, function(){
                    var element = $( this.element );
                    var element_label = element.closest( "form" ).find( "label[for='" + element.attr( "id" ) + "']" ).first().text();
                    messages.push(element_label + ' ' + this.message);
                });
                //showResult(messages.join('<br>'), 'error');
            }
            else {
                //hideResult();
            }
            this.defaultShowErrors();
        },
        */
        submitHandler: function() {
            tablesPost();
        }

    });
}

function tablesPost() {

    var cform = $('#tables-form');

    cform.find('li.submit>button')
    .attr('disabled', true)
    .addClass('working');

    var tableRequest = cform.serializeArray();

    $.map(tableRequest, function(data){
        switch(data.name) {
            case 'phone_number':
            data.value = $('#phone_number', cform).intlTelInput('getNumber');
            break;
           /*case 'comments':
               data.value = $.validator.format("{0}\n{1}\n\n{2}", [
                   $('#location', cform).val(),
                   $('#date option:selected', cform).text(),
                   data.value
               ]);
               break;*/
           }
           return data;
       });

    var smessage = $('#tables-submit').data('thanks') || 'Success!';
    var stitle = $('#tables-submit').data('success') || 'Thank you for your interest in booking a table. <br>We have received your information and will get in touch with you soon.';

    $.ajax({
        type: 'POST',
        url: 'https://admin.resistanceibiza.com/api/v1/reservation?key=a1fd55fc91966c363621cc235a90221d',
        data: tableRequest,
        dataType: 'html text'
    }).done(function(data){
        cform.fadeOut(300).promise()
        .then(cform.find('ol').remove().promise())
        .then($("#viptables>h1, #viptables>p, #viptables>.lbreak").fadeOut(300).promise())
        .then(cform.append('<div class="result text-center"><h1 style="margin-bottom:20px;">'+stitle+'</h1><p style="font-size:16px;">'+smessage+'</p></div>').promise())
        .then(cform.fadeIn(300).promise());

    }).fail(function(xhr, ajaxOptions, thrownError){
        log(xhr, ajaxOptions, thrownError);
        log(xhr.responseText);

        var errortext = xhr.responseText;

        if( xhr.responseText == '{"error":"undefined method \`message\' for :event_date:Symbol"}' ) {
            errortext = "<u>Invalid Date Selected</u>";
        }
        if( xhr.responseText == '{"error":"undefined method \`message\' for :client_name:Symbol"}' ) {
            errortext = "<u>You must enter Your Name</u>";
        }
        if( xhr.responseText == '{"error":"undefined method \`message\' for :arrival_time:Symbol"}' ) {
            errortext = "<u>You must select an Arrival Time</u>";
        }
        if( xhr.responseText == '{"error":"undefined method \`message\' for :people:Symbol"}' ) {
            errortext = "<u>You must choose a Party Size</u>";
        }
        if( xhr.responseText == '{"error":"undefined method \`message\' for :client_email:Symbol"}' ) {
            errortext = "<u>You must enter Your Email</u>";
        }

        cform.find('.error-output')
        .html('ERROR: '+errortext+'. Please try again. If you continue to experience issues, please email info@ultramusicfestival.com')
        .fadeIn(300).promise()
        .then(cform.find('li.submit>button').attr('disabled', false).removeClass('working'));
    });
}
